import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/src/components/ui/button.tsx");
